/**
 * GENERATED FILE — do not edit by hand.
 *
 * Written by `vendor/bin/sail artisan make:ts-interfaces` in the tabasco backend and
 * copied into tabasco-vue/src/ts. A hand-edit is lost on the next run, and patching a
 * single model leaves every other model in the file stale.
 *
 * To change something here, change its source in the backend — the model's casts(),
 * elasticMappings(), or its relations — then regenerate the WHOLE file. Generate from a
 * database that matches the schema the code expects: the generator reads column
 * nullability live, so a stale local database silently rewrites unrelated models.
 */

export const modelNames = {
    "Account": true,
    "AccountStatus": true,
    "Address": true,
    "Addressable": true,
    "Album": true,
    "Artist": true,
    "ArtistAlias": true,
    "AudioFileIssue": true,
    "AudioFileStates": true,
    "AudioFileVerificationState": true,
    "BannedArtist": true,
    "BannedTrack": true,
    "Brand": true,
    "Bucket": true,
    "BucketArtistOverride": true,
    "BucketGenre": true,
    "BucketTagOverride": true,
    "BucketTrackOverride": true,
    "BucketType": true,
    "BulkActionName": true,
    "BulkActionRun": true,
    "BulkActionRunItem": true,
    "BulkActionRunItemOutcome": true,
    "BulkActionRunItemVerdict": true,
    "BulkActionRunStatus": true,
    "CannedNoteSubject": true,
    "CannedNoteSubjectType": true,
    "Categorizable": true,
    "CategorizablePivot": true,
    "Category": true,
    "CategoryType": true,
    "ClientwebSubmission": true,
    "Contact": true,
    "ContactLogin": true,
    "ContactLoginCustomPlaylist": true,
    "ContactLoginCustomPlaylistTrack": true,
    "ContactLoginPlayer": true,
    "ContactLoginStation": true,
    "ContactLoginStationSourceType": true,
    "ContactLoginType": true,
    "Contactable": true,
    "ContentStyle": true,
    "Country": true,
    "CronDdexMatchStatus": true,
    "CronDdexRun": true,
    "CronDdexStageStatus": true,
    "CronDdexTrack": true,
    "CronDdexTracksDeal": true,
    "CronDdexTracksTakedownStatus": true,
    "CronDdexXmlFile": true,
    "CrossfadeType": true,
    "CustomPlaylistInsertType": true,
    "CustomPlaylistScheduleType": true,
    "CustomPlaylistSwitchStat": true,
    "Day": true,
    "DdexConfiguration": true,
    "DynamoDbBaseModel": true,
    "DynamoDbTableStatistic": true,
    "DynamoPrimaryKeyQueue": true,
    "Extension": true,
    "FavoriteFilter": true,
    "FileDownload": true,
    "Genre": true,
    "Holiday": true,
    "Insert": true,
    "LiveTrack": true,
    "LiveTrackAction": true,
    "LiveTrackActionStatus": true,
    "LiveTrackDeal": true,
    "LiveTrackEchoprintState": true,
    "LiveTrackMatch": true,
    "LiveTrackMatchType": true,
    "LiveTrackPlayDynamo": true,
    "LiveTrackPlaySummary": true,
    "LiveTrackReportSnapshot": true,
    "Location": true,
    "LocationStatus": true,
    "LocationZone": true,
    "LocationZoneContentChangeLog": true,
    "LocationZoneContentPublish": true,
    "LocationZoneContentPublishSource": true,
    "LocationZoneContentState": true,
    "LocationZoneCustomPlaylist": true,
    "LocationZoneCustomPlaylistSchedule": true,
    "LocationZoneCustomPlaylistSource": true,
    "LocationZoneCustomPlaylistStatus": true,
    "LocationZoneCustomPlaylistTrack": true,
    "LocationZoneFee": true,
    "LocationZoneHour": true,
    "LocationZonePlaybackTimeframe": true,
    "LocationZonePlayer": true,
    "LocationZonePlayerCommandEnum": true,
    "LocationZonePlayerCommandHistory": true,
    "LocationZonePlayerCommandQueue": true,
    "LocationZonePlayerData": true,
    "LocationZonePlayerHolidayMusicStatus": true,
    "LocationZonePlayerParsedPlaylist": true,
    "LocationZonePlayerParsedPlaylistTrack": true,
    "LocationZonePlayerPlaylist": true,
    "LocationZonePlayerPlaylistDynamo": true,
    "LocationZonePlayerStreamMode": true,
    "LocationZoneStatus": true,
    "LocationZoneTier": true,
    "LocationZoneVote": true,
    "LyricsCheckStatus": true,
    "LzpLogs2": true,
    "MasterServiceAgreement": true,
    "ModelPermissionDefinition": true,
    "ModelSnapshot": true,
    "MonthlyActiveZone": true,
    "MusicZoneFolder": true,
    "Note": true,
    "NoteBox": true,
    "NoteType": true,
    "NoteUser": true,
    "NotionSlackChannel": true,
    "NotionSlackMessage": true,
    "NotionWebhookEvent": true,
    "NotionWebhookVerificationToken": true,
    "OrchardTrack": true,
    "OverrideType": true,
    "PageDefinition": true,
    "ParentalAdvisoryType": true,
    "Part": true,
    "PartEntry": true,
    "PaymentType": true,
    "PerPlayCountryOandaExchangeRate": true,
    "PerPlayCountryRate": true,
    "PerPlayDailyData": true,
    "PerPlayMobileData": true,
    "PerPlayReportGenerationAttempt": true,
    "PerPlaySourceType": true,
    "PerPlayWebData": true,
    "PerPlayWebsamplelistData": true,
    "PhoneNumber": true,
    "Phoneable": true,
    "PlayLogImportProgress": true,
    "Player": true,
    "PlayerServer": true,
    "PlayerType": true,
    "PlaylistGenerationAttempt": true,
    "PlaylistGenerationFailure": true,
    "PlaylistGenerationStatus": true,
    "PlaylistManagerGroup": true,
    "PlaylistTrack": true,
    "PlaylistTrackCount": true,
    "PlaylistTrackRefreshChangedTrack": true,
    "RawDdexErnMessage": true,
    "RawDdexInvalidLabelUrlCheck": true,
    "RawDdexMessageType": true,
    "RawDdexParty": true,
    "RawDdexPartyExclusion": true,
    "RawDdexReleaseType": true,
    "RawDdexSoundRecordingRelease": true,
    "RawDdexTrack": true,
    "RawDdexTrackEchoprintState": true,
    "RawDdexTrackFingerprintMatch": true,
    "RawDdexTrackTakedownStatus": true,
    "RawDdexXmlFile": true,
    "RecordLabel": true,
    "RecordLayout": true,
    "RefreshToken": true,
    "Region": true,
    "RoyaltyImportProgress": true,
    "SavedView": true,
    "ScheduleHistory": true,
    "SchedulingMode": true,
    "SharedSavedView": true,
    "ShortClipPlaybackType": true,
    "StagedTrack": true,
    "StagedTrackProcessType": true,
    "StagedTrackSource": true,
    "State": true,
    "StreamMode": true,
    "Tag": true,
    "Taggable": true,
    "Template": true,
    "TemplateDay": true,
    "TemplateDayInsert": true,
    "TimeZone": true,
    "TrackLyrics": true,
    "TrackMatchStatus": true,
    "TrackStreamType": true,
    "User": true,
    "UserModelPermission": true,
    "UserPageGrant": true,
    "VoteReason": true,
    "VoteType": true,
    "Worklist": true,
    "Zp": true,
    "ZpDynamo": true,
    "ZpgaLog": true,
    "Zt": true
};

export default modelNames;

/** Marker for models implementing the searchable UI contract (see models.json _searchable). */
export type Searchable = object;

export interface AccountStatus {
  id: number;
  accounts: Account[];
  created_at: Date;
  name: string;
  updated_at: Date;
}

export interface Address {
  id: number;
  address_1: string;
  address_2: string | null;
  addressables: Addressable[];
  categories: Category;
  city: string;
  country: Country;
  country_id: number | null;
  is_archived: boolean;
  latitude: number | null;
  longitude: number | null;
  state: State;
  state_id: number | null;
  subdivision: string | null;
  zip: string | null;
}

export interface Addressable {
  id: number;
  address: Address;
  address_id: number;
  created_at: Date | null;
  f_id: number;
  f_type: string;
  owner: Addressable;
  updated_at: Date;
}

export interface ArtistAlias {
  id: number;
  artist: Artist;
  artist_id: number | null;
  created_at: Date | null;
  name: string | null;
  updated_at: Date;
}

export interface AudioFileIssue {
  id: number;
  details: any[] | null;
  issue_type: 'GvlibraryMissing' | 'GvlibrarySizeMismatch' | 'GvlibraryUnreadable' | 'OriginalMissing' | 'OriginalUnreadable' | 'VbrDetected' | 'BitrateMismatch' | 'LowBitrate' | 'HlsMasterMissing' | 'HlsVariantMissing' | 'HlsChunkCountMismatch' | 'HlsMasterUnplayable' | 'HlsUnreadable' | 'Mp3valError' | 'Mp3valWarning' | 'Mp3valNotRun' | 'NormalizationMetadataMissing';
  live_track: LiveTrack;
  live_track_id: number;
  severity: 'Error' | 'Warning' | 'Info';
  verified_at: Date;
}

export interface AudioFileStates {
  id: number;
  last_pass_a_rerun_at: Date | null;
  live_track: LiveTrack;
  live_track_id: number;
}

export interface AudioFileVerificationState {
  id: number;
  gvlibrary_bitrate_kbps: number | null;
  is_vbr: boolean | null;
  last_file_updated_at: Date | null;
  last_verified_at: Date | null;
  live_track: LiveTrack;
  live_track_id: number;
  original_bitrate_kbps: number | null;
  original_status_verified_at: Date | null;
  vbr_detected_at: Date | null;
}

export interface BannedArtist {
  id: number;
  artist: Artist;
  artist_id: number;
  created_at: Date | null;
  deleted_at: Date | null;
  location_zone_id: number;
  updated_at: Date;
  user: User;
  user_id: number | null;
}

export interface BannedTrack {
  id: number;
  created_at: Date | null;
  deleted_at: Date | null;
  location_zone_id: number;
  track: LiveTrack;
  track_id: number;
  user: User;
  user_id: number | null;
}

export interface Brand {
  id: number;
  name: string;
  short_name: string | null;
  url: string;
}

export interface BucketArtistOverride {
  id: number;
  artist: Artist;
  artist_id: number;
  bucket: Bucket;
  bucket_id: number;
  override_type: OverrideType;
  override_type_id: number;
  user: User;
  user_id: number | null;
}

export interface BucketGenre {
  id: number;
  bucket: Bucket;
  bucket_id: number;
  bucket_weight: number;
  created_at: Date | null;
  genre: Genre;
  genre_id: number;
  is_dynamic: boolean;
  type: number;
  updated_at: Date;
  user: User;
  user_id: number | null;
}

export interface BucketTagOverride {
  id: number;
  bucket: Bucket;
  bucket_id: number;
  created_at: Date | null;
  tag: Tag;
  tag_id: number;
  type: number;
  user: User;
  user_id: number | null;
}

export interface BucketTrackOverride {
  id: number;
  bucket: Bucket;
  bucket_id: number;
  override_type: OverrideType;
  override_type_id: number;
  track: LiveTrack;
  track_id: number;
  user: User;
  user_id: number | null;
}

export interface BucketType {
  id: number;
  buckets: Bucket[];
  created_at: Date | null;
  name: string;
  updated_at: Date | null;
}

export interface BulkActionName {
  id: number;
  name: string;
}

export interface BulkActionRun {
  id: number;
  bulk_action_name: BulkActionName;
  bulk_action_name_id: number;
  bulk_action_run_items: BulkActionRunItem[];
  bulk_action_run_status: BulkActionRunStatus;
  bulk_action_run_status_id: number;
  created_at: Date;
  delete_impact: any[] | null;
  expires_at: Date;
  finished_at: Date | null;
  invalid_count: number;
  no_value_count: number;
  not_found_count: number;
  operation: any[];
  queued_at: Date | null;
  selected_count: number;
  skipped_for_access_count: number;
  started_at: Date | null;
  unchanged_count: number;
  updated_at: Date;
  user: User;
  user_id: number;
  will_change_count: number;
}

export interface BulkActionRunItem {
  id: number;
  bulk_action_run: BulkActionRun;
  bulk_action_run_id: number;
  bulk_action_run_item_outcome: BulkActionRunItemOutcome;
  bulk_action_run_item_outcome_id: number | null;
  bulk_action_run_item_verdict: BulkActionRunItemVerdict;
  bulk_action_run_item_verdict_id: number;
  created_at: Date;
  location: Location;
  location_id: number | null;
  location_zone: LocationZone;
  location_zone_custom_playlist: LocationZoneCustomPlaylist;
  location_zone_custom_playlist_id: number | null;
  location_zone_id: number | null;
  no_value_fields: any[] | null;
  position: number;
  record_id: number;
  updated_at: Date;
}

export interface BulkActionRunItemOutcome {
  id: number;
  name: string;
}

export interface BulkActionRunItemVerdict {
  id: number;
  name: string;
}

export interface BulkActionRunStatus {
  id: number;
  name: string;
}

export interface CannedNoteSubject {
  id: number;
  canned_note_subject_type: CannedNoteSubjectType;
  canned_note_subject_type_id: number;
  created_at: Date | null;
  name: string | null;
  updated_at: Date | null;
}

export interface CannedNoteSubjectType {
  id: number;
  canned_note_subjects: CannedNoteSubject[];
  created_at: Date | null;
  group_name: string | null;
  name: string | null;
  updated_at: Date | null;
}

export interface Categorizable {
  id: number;
  category: Category;
  category_id: number | null;
  created_at: Date | null;
  f_id: number | null;
  f_type: string | null;
  updated_at: Date | null;
}

export interface CategorizablePivot {
  id: number;
  category_id: number | null;
  f_id: number | null;
}

export interface Category {
  id: number;
  category_type: CategoryType;
  category_type_id: number;
  deleted_at: Date | null;
  name: string;
  short_name: string;
}

export interface CategoryType {
  id: number;
  categories: Category[];
  deleted_at: Date | null;
}

export interface ClientwebSubmission {
  id: number;
  account: Account;
  account_id: number | null;
  clientweb_submission_method_id: number | null;
  clientweb_submission_source_id: number | null;
  contact: Contact;
  contact_id: number | null;
  created_at: Date;
  diff: string | null;
  headers: string | null;
  ip_address: string | null;
  is_processed: boolean;
  request: string | null;
  request_encoded: string | null;
  response: string | null;
  session_id: string;
  updated_at: Date;
  uri: string | null;
}

export interface ContactLogin {
  id: number;
  allow_comments_without_votes: boolean;
  allows_skipping: boolean;
  always_reset_stations: boolean | null;
  contact: Contact;
  contact_id: number;
  contact_login_type: ContactLoginType;
  contact_login_type_id: number;
  created_at: Date | null;
  force_password_reset: boolean | null;
  international_playback: boolean;
  is_active: boolean;
  is_archived: boolean;
  laravel_password: string | null;
  login_attempts: number;
  master_contact_login: ContactLogin;
  master_contact_login_id: number | null;
  password: string;
  remember_token: string | null;
  should_debug: boolean;
  unlimited_skipping: boolean;
  updated_at: Date | null;
}

export interface ContactLoginCustomPlaylistTrack {
  id: number;
  contact_login_custom_playlist_id: number;
  created_at: Date;
  position: number;
  track: LiveTrack;
  track_id: number;
}

export interface ContactLoginPlayer {
  id: number;
  contact_login: ContactLogin;
  contact_login_id: number;
  initial_contact_date: Date | null;
  is_archived: boolean;
  last_follow_up_date: Date | null;
  player_id: number;
  shutdown_notice_date: Date | null;
  updated_at: Date | null;
}

export interface ContactLoginStationSourceType {
  id: number;
  name: string | null;
  table_name: string | null;
}

export interface ContactLoginType {
  id: number;
  name: string;
}

export interface Contactable {
  id: number;
  contact: Contact;
  contact_id: number;
  created_at: Date | null;
  f_id: number;
  f_type: string;
  is_archived: boolean;
  owner: Contactable;
  updated_at: Date;
}

export interface ContentStyle {
  id: number;
  name: string | null;
  summary: string | null;
}

export interface Country {
  id: number;
  code: string;
  created_at: Date | null;
  name: string;
  sort_value: number;
  subdivision_type: string | null;
  updated_at: Date;
}

export interface CronDdexMatchStatus {
  id: number;
  reason: string | null;
}

export interface CronDdexRun {
  id: number;
  end_run: Date | null;
  errors: string | null;
  errors_ddex: string | null;
  imported_tracks: string | null;
  running: boolean | null;
  start_run: Date | null;
  tracks_processed: number | null;
  tracks_processed_ended_at: Date | null;
  tracks_processed_started_at: Date | null;
  updated_tracks: string | null;
}

export interface CronDdexStageStatus {
  id: number;
  name: string | null;
}

export interface CronDdexTrack {
  id: number;
  album_artist_name: string | null;
  album_ean: string | null;
  album_name: string | null;
  album_upc: string | null;
  artist_name: string | null;
  bitrate: number | null;
  catalog_code: string | null;
  checksum: string | null;
  copyright: number | null;
  cover_art_signed_url: string | null;
  cover_image_checksum: string | null;
  cover_image_file_path: string | null;
  cover_image_processed: boolean | null;
  created_at: Date;
  ddex_xml_file: CronDdexXmlFile;
  ddx_file: CronDdexXmlFile;
  ddx_file_id: number | null;
  ddx_original_file: CronDdexXmlFile;
  ddx_original_file_id: number | null;
  ddx_update_file: CronDdexXmlFile;
  ddx_update_file_id: number | null;
  duration: number | null;
  error_status: number | null;
  file_path: string | null;
  genre_name: string | null;
  isrc: string | null;
  major_record_label_name: string | null;
  match_status: CronDdexMatchStatus;
  match_status_id: number | null;
  message_date: Date | null;
  name: string | null;
  parental_advisory: string | null;
  publishers: string | null;
  record_label_name: string | null;
  release_album_catalog_number: string | null;
  release_album_grid: string | null;
  release_album_icpn: string | null;
  release_grid: string | null;
  run: CronDdexRun;
  run_id: number;
  solr_status: number | null;
  stage_status: CronDdexStageStatus;
  stage_status_id: number | null;
  stage_updated: Date | null;
  sub_genre_name: string | null;
  sub_title: string | null;
  take_down: boolean | null;
  take_down_territories: string | null;
  track_duplicate_artists: string | null;
  track_duplicate_ids: string | null;
  track_duplicate_is_processed: boolean | null;
  track_duplicate_names: string | null;
  track_similar_artists: string | null;
  track_similar_ids: string | null;
  track_similar_names: string | null;
  track_tags_processed: boolean | null;
  update_indicator: number | null;
  updated_at: Date | null;
  uploaded_to_s3: number | null;
  us_take_down: boolean | null;
}

export interface CronDdexTracksDeal {
  id: number;
  created_at: Date | null;
  ddx_file_id: number | null;
  deal_commercial_type: string | null;
  deal_end: Date | null;
  deal_start: Date | null;
  deal_territory: string | null;
  deal_territory_excluded: string | null;
  deal_use_type: string | null;
  effective_date: Date | null;
  message_date: Date | null;
  run_id: number;
  track_id: number | null;
  updated_at: Date | null;
}

export interface CronDdexTracksTakedownStatus {
  id: number;
  description: string;
  name: string;
}

export interface CronDdexXmlFile {
  id: number;
  ack_status: number | null;
  checksum: string | null;
  cover_art_processed: number | null;
  cron_ddex_tracks: CronDdexTrack[];
  cron_ddex_xml_release_type_id: number | null;
  ddex_ern_version: number | null;
  ddex_processed: number;
  error_status: boolean | null;
  file_name: string;
  file_type: boolean | null;
  folder_path: string;
  folder_path_s3: string | null;
  generated_ack: number | null;
  hostname: string;
  message_date: Date | null;
  message_id: string | null;
  message_thread_id: string | null;
  party_id_receiver: string | null;
  party_id_sender: string | null;
  party_id_sent_on_behalf: string | null;
  processed: number;
  processed_date: Date;
  re_indexed: boolean | null;
  removed_disk: number | null;
  run_id: number | null;
  tracks_processed: number | null;
  update_indicator: number | null;
  uploaded_s3: boolean;
  uploaded_temp_s3: boolean;
}

export interface CrossfadeType {
  id: number;
  name: string | null;
  players: Player[];
}

export interface CustomPlaylistInsertType {
  id: number;
  name: string | null;
}

export interface CustomPlaylistScheduleType {
  id: number;
  name: string | null;
}

export interface CustomPlaylistSwitchStat {
  id: number;
  contact: Contact;
  contact_id: number;
  location_zone_custom_playlist: LocationZoneCustomPlaylist;
  location_zone_custom_playlist_id: number;
  report_date: Date;
  switch_count: number;
}

export interface Day {
  id: number;
  created_at: Date | null;
  name: string;
  short_name: string;
  updated_at: Date;
}

export interface DdexConfiguration {
  id: number;
  created_at: Date | null;
  created_by_user: User;
  created_by_user_id: number | null;
  enabled: boolean;
  exclusions: RawDdexPartyExclusion[];
  raw_ddex_party_sender_id: number;
  s3_import_path: string;
  sender: RawDdexParty;
  updated_at: Date | null;
}

/** Placeholder: no generated scalar fields (see models.json for metadata). */
export type DynamoDbBaseModel = object;

export interface LiveTrackPlayDynamo {
  country_id: number;
  ip_address: string;
  job_id: string;
  live_track_code: string;
  live_track_id: number;
  partition_key: string;
  play_month: string;
  play_month_country: string;
  play_timestamp: number;
  player_primary_key: string;
  player_type_id: number;
  track_id_country_id_track_stream_type_id: string;
  track_stream_type_id: number;
}

export interface LocationZonePlayerCommandHistory {
  acknowledged_at: number;
  command: string;
  command_hash: string;
  command_id: string;
  command_truncated: boolean;
  delivered_at: number;
  expires_at: number;
  issued_at: number;
  location_zone_player_id: number;
  skipped_reason: string;
  source: string;
  state: string;
}

export interface LocationZonePlayerPlaylistDynamo {
  id: number;
  created_at: Date;
  days_remaining: number;
  location_zone_player_id: number;
  playlists: string;
  updated_at: Date;
}

export interface LzpLogs2 {
  created_at: Date;
  live_track: LiveTrack;
  location_zone_player_id: number;
  message: string;
  time: number;
  track_code: string;
}

export interface PerPlayDailyData {
  code: string;
  country: Country;
  created_at: Date;
  date: string;
  live_track: LiveTrack;
  remote_address: string;
  stream: boolean;
  stream_id: string;
  time: number;
  track_stream_type_id: number;
}

export interface PerPlayMobileData {
  code: string;
  contact_id: number;
  country: Country;
  country_code: string;
  created_at: Date;
  live_track: LiveTrack;
  remote_address: string;
  station_id: number;
  timestamp: number;
  track_stream_type_id: number;
}

export interface PerPlayWebData {
  id: string;
  code: string;
  country: Country;
  created_at: Date;
  listid: number;
  live_track: LiveTrack;
  remote_address: string;
  timestamp: number;
  track_stream_type_id: number;
}

export interface PerPlayWebsamplelistData {
  code: string;
  country: Country;
  country_code: string;
  created_at: Date;
  live_track: LiveTrack;
  remote_address: string;
  timestamp: number;
  token: string;
}

export interface ZpDynamo {
  id: number;
  archive_name: string;
  attempt_time_stamp: Date;
  created_at: Date;
  delimited_bucket_ids: string;
  delimited_track_codes: string;
  delimited_track_details: string;
  delimited_track_ids: string;
  expiry_timestamp: number;
  file_name: string;
  location_zone_id: number;
  play_date: Date;
  play_date_time: Date;
  playlist_generation_attempt_id: number;
  playlist_generation_attempt_id_play_date_time: number;
  success: number;
  tableName: string;
  updated_at: number;
  utc_attempt_timestamp: number;
}

export interface DynamoDbTableStatistic {
  id: number;
  captured_at: Date;
  item_count: number;
  size_bytes: number;
}

export interface DynamoPrimaryKeyQueue {
  id: number;
  failure_count: number;
  pk_value: string;
  processing_started_at: Date | null;
  table_name: string;
}

export interface Extension {
  id: number;
  created_at: Date | null;
  number: string;
  parent_id: number;
  parent_type: string;
  phone_number_id: number;
  updated_at: Date;
}

export interface FavoriteFilter {
  id: number;
  created_at: Date | null;
  entity: string;
  label: string;
  rule: any[];
  signature: string;
  signature_hash: string;
  updated_at: Date | null;
  user: User;
  user_id: number;
}

export interface FileDownload {
  id: number;
  created_at: Date | null;
  error_message: string | null;
  file_name: string;
  status: 'DOWNLOADING' | 'SUCCESS' | 'FAILURE';
  updated_at: Date | null;
}

export interface Genre {
  id: number;
  comments: string | null;
  created_at: Date | null;
  deleted_at: Date | null;
  g_description: string | null;
  live_tracks: LiveTrack[];
  name: string | null;
  summary: string | null;
  tags: Tag;
  updated_at: Date;
  variation: number | null;
}

export interface Holiday {
  id: number;
  name: string;
  natural_language_description: string;
  normalized_name: string;
}

export interface Insert {
  id: number;
  allow_repeats: boolean | null;
  created_at: Date | null;
  disabled: boolean;
  duration: number;
  duration_type: number | null;
  end_date: Date;
  frequency: number;
  name: string;
  object: Bucket;
  object_id: number;
  object_type: string;
  play_type: number | null;
  saturation: number | null;
  start_date: Date;
  template: Template;
  template_id: number;
  updated_at: Date;
}

export interface LiveTrackActionStatus {
  id: number;
  name: string;
}

export interface LiveTrackDeal {
  id: number;
  commercial_model_type: any[];
  excluded_territory_codes: any[] | null;
  live_track: LiveTrack;
  live_track_id: number;
  territory_codes: any[];
  usage: any[];
  validity_period_end_date: Date | null;
  validity_period_start_date: Date | null;
}

export interface LiveTrackEchoprintState {
  id: number;
  created_at: Date | null;
  live_track: LiveTrack;
  live_track_id: number;
  reingested_at: Date | null;
  updated_at: Date | null;
}

export interface LiveTrackMatch {
  id: number;
  confidence_score: number | null;
  created_at: Date | null;
  fingerprint_match: boolean;
  fingerprint_via: string | null;
  fuzzy_match: boolean;
  isrc_match: boolean;
  live_track: LiveTrack;
  live_track_id: number;
  matched_track_data: any[];
  matched_track_id: string;
  source_type: string;
  updated_at: Date | null;
}

export interface LiveTrackMatchType {
  id: number;
  created_at: Date | null;
  live_track_matches: LiveTrackMatch[];
  name: string;
  updated_at: Date | null;
}

export interface LiveTrackPlaySummary {
  id: number;
  country: Country;
  country_id: number | null;
  live_track: LiveTrack;
  live_track_id: number;
  per_play_source_type: PerPlaySourceType;
  per_play_source_type_id: number;
  play_month: string;
  plays: number;
  track_stream_type: TrackStreamType;
  track_stream_type_id: number;
}

export interface LiveTrackReportSnapshot {
  id: number;
  album_display_string: string | null;
  album_id: number | null;
  album_upc: string | null;
  artist_display_string: string | null;
  artist_id: number | null;
  catalog_code: string | null;
  is_partner: boolean | null;
  isrc: string | null;
  live_track_id: number;
  record_label_display_string: string | null;
  record_label_id: number | null;
  report_month: number;
  root_record_label_display_string: string | null;
  root_record_label_id: number | null;
  track_name: string | null;
}

export interface LocationStatus {
  id: number;
  deleted_at: Date | null;
}

export interface LocationZoneContentChangeLog {
  id: number;
  created_at: Date;
  custom_playlist: LocationZoneCustomPlaylist;
  location_zone: LocationZone;
  location_zone_custom_playlist_id: number | null;
  location_zone_id: number;
  requires_publish: boolean;
  subject_id: number | null;
  subject_name: string | null;
  user: User;
  user_id: number | null;
}

export interface LocationZoneContentPublish {
  id: number;
  command_id: string | null;
  created_at: Date;
  location_zone: LocationZone;
  location_zone_content_publish_source_id: number;
  location_zone_id: number;
  players_skipped: number;
  players_targeted: number;
  source: LocationZoneContentPublishSource;
  user: User;
  user_id: number | null;
}

export interface LocationZoneContentPublishSource {
  id: number;
  name: string;
}

export interface LocationZoneContentState {
  id: number;
  content_changed_at: Date | null;
  location_zone: LocationZone;
  location_zone_id: number;
}

export interface LocationZoneCustomPlaylistSource {
  id: number;
  details: string | null;
  location_zone_custom_playlist_sources: string | null;
  name: string | null;
}

export interface LocationZoneCustomPlaylistStatus {
  id: number;
  name: string | null;
}

export interface LocationZoneCustomPlaylistTrack {
  id: number;
  created_at: Date | null;
  location_zone_custom_playlist: LocationZoneCustomPlaylist;
  location_zone_custom_playlist_id: number;
  position: number;
  track: LiveTrack;
  track_id: number;
}

export interface LocationZoneFee {
  id: number;
  invoicing_approved: boolean | null;
  location_zone: LocationZone;
  location_zone_id: number | null;
  original_startup_fee: number | null;
  original_subscription_fee: number | null;
  past_due_amount: number | null;
  past_due_assigned_to_user_id: number | null;
  past_due_days: number | null;
  payments_tally: number;
  primary_pro_location_zone: LocationZone;
  primary_pro_location_zone_id: number | null;
  service_agreement_term_id: number | null;
  shipping_fee: number | null;
  startup_date: Date | null;
  startup_fee: number | null;
  startup_fee_is_paid: boolean | null;
  startup_invoice_balance_status_id: number | null;
  startup_invoicing_status_id: number | null;
  subscription_fee: number | null;
  subscription_invoicing_status_id: number | null;
  term_end_date: Date | null;
  zero_startup_fee_reason: string | null;
}

export interface LocationZoneHour {
  id: number;
  close_time: string | null;
  created_at: Date;
  day_id: number;
  deleted_at: Date | null;
  is_closed: boolean | null;
  location_zone: LocationZone;
  location_zone_id: number;
  open_time: string | null;
  updated_at: Date;
}

export interface LocationZonePlaybackTimeframe {
  id: number;
  day_of_week: number;
  end_time: string;
  location_zone: LocationZone;
  location_zone_id: number;
  start_time: string;
}

export interface LocationZonePlayerCommandEnum {
  id: number;
  command: string;
  is_hardware_player_command_only: boolean;
  is_virtual_player_command_only: boolean;
  json_command: string | null;
  menu_name: string | null;
  name: string;
  position: number | null;
  requires_legacy_handler: boolean;
  should_prefix_separator: boolean;
  version_maximum: string | null;
  version_minimum: string | null;
}

export interface LocationZonePlayerCommandQueue {
  id: number;
  command: string;
  created_at: Date;
  issued_at: Date | null;
  location_zone_player: LocationZonePlayer;
  location_zone_player_id: number;
  scheduled_time: Date | null;
}

export interface LocationZonePlayerData {
  id: number;
  account: Account;
  channels: string | null;
  checkin_marker: Date | null;
  created_at: Date | null;
  current_playlist_name: string | null;
  current_track_code: string | null;
  date: Date | null;
  disk_size_gb: number | null;
  disk_usage: string | null;
  disk_usage_percentage: number | null;
  drive: string | null;
  gateway: string | null;
  internal_ip: string | null;
  ip_mode: string | null;
  is_internal: boolean;
  is_online: boolean;
  kernel: string | null;
  lan: string | null;
  last_loaded_archive: string | null;
  last_loaded_date: Date | null;
  location: Location;
  location_zone: LocationZone;
  location_zone_player: LocationZonePlayer;
  location_zone_player_id: number | null;
  mac_address: string | null;
  model_type: string | null;
  network_info: string | null;
  player_type: PlayerType;
  player_type_id: number | null;
  playing: number;
  playlist_track_number: number;
  playlist_track_total: number;
  proxy: string | null;
  referenced_content_missing: number;
  referenced_content_total: number;
  remote_ip: string | null;
  subnet: string | null;
  time_zone: string | null;
  updated_at: Date | null;
  version: string | null;
  volume: number | null;
}

export interface LocationZonePlayerHolidayMusicStatus {
  id: number;
  created_at: Date | null;
  has_played_holiday_music: boolean;
  last_checked_at: Date | null;
  last_holiday_play_at: Date | null;
  location_zone_player_id: number;
  track_id: number | null;
  updated_at: Date | null;
}

export interface LocationZonePlayerParsedPlaylist {
  id: number;
  created_at: Date | null;
  location_zone_id: number | null;
  location_zone_player_id: number;
  playlist_id: number | null;
  playlist_name: string;
  table_name: string;
  updated_at: Date | null;
}

export interface LocationZonePlayerPlaylist {
  id: number;
  created_at: Date | null;
  days_remaining: number | null;
  location_zone_id: number | null;
  location_zone_player: LocationZonePlayer;
  location_zone_player_id: number | null;
  playlists: string | null;
  updated_at: Date | null;
}

export interface LocationZonePlayerStreamMode {
  id: number;
  location_zone_players: LocationZonePlayer[];
  name: string | null;
}

export interface LocationZoneStatus {
  id: number;
  created_at: Date | null;
  name: string | null;
  updated_at: Date | null;
}

export interface LocationZoneTier {
  id: number;
  name: string;
}

export interface LocationZoneVote {
  id: number;
  clonedFromLocationZoneVote: LocationZoneVote;
  cloned_from_location_zone_vote_id: number | null;
  comment: string | null;
  contact: Contact;
  contact_id: number | null;
  created_at: Date;
  deleted_at: Date | null;
  is_internal_comment: boolean;
  locationZone: LocationZone;
  location_zone_id: number;
  source_name: string | null;
  track: LiveTrack;
  track_id: number;
  updated_at: Date;
  user: User;
  user_id: number | null;
  vote: number;
  voteReason: VoteReason;
  voteType: VoteType;
  vote_reason_id: number | null;
  vote_type_id: number | null;
}

export interface LyricsCheckStatus {
  id: number;
  name: string | null;
}

export interface MasterServiceAgreement {
  id: number;
  created_at: Date | null;
  name: string;
  updated_at: Date | null;
}

export interface ModelPermissionDefinition {
  id: number;
  created_at: Date | null;
  sort_order: number;
  updated_at: Date | null;
}

export interface ModelSnapshot {
  id: number;
  changes: string;
  created_at: Date | null;
  payload: string;
  performed_by_user: User;
  performed_by_user_id: number | null;
  table: string;
  updated_at: Date | null;
}

export interface MonthlyActiveZone {
  id: number;
  account: string;
  account_id: number;
  country: Country;
  country_id: number | null;
  equipment_fee: number | null;
  location: string;
  location_id: number;
  net_monthly_revenue: number | null;
  primary_pro_location_zone: string | null;
  primary_pro_location_zone_id: number | null;
  pro_fee: number | null;
  pro_zone_fee: number | null;
  report_month: number;
  startup_date: Date | null;
  startup_fee: number;
  subscription_fee: number;
  zone: string;
  zone_id: number;
}

export interface Note {
  id: number;
  assigned_user: User;
  assigned_user_id: number | null;
  completed_notification_was_sent: boolean;
  created_at: Date | null;
  due_date: Date | null;
  due_date_is_enabled: boolean;
  is_archived: boolean;
  is_complete: boolean;
  is_high_priority: boolean | null;
  is_tpg_note: boolean | null;
  last_notification_date: Date | null;
  last_past_due_notification_date: Date | null;
  message: string;
  note_type_id: number;
  parent: Note;
  parent_id: number | null;
  parent_note_id: number | null;
  parent_string_value: string | null;
  parent_type: string | null;
  reference_message_id: string | null;
  start_date: Date | null;
  start_date_is_enabled: boolean;
  start_notification_was_sent: boolean;
  subject: string;
  time_zone: TimeZone;
  time_zone_id: number | null;
  updated_at: Date;
  user: User;
  user_id: number;
}

export interface NoteBox {
  id: number;
  assigned_to_user: User;
  assigned_to_user_id: number | null;
  belongs_to_parent_id: number | null;
  belongs_to_parent_type: string | null;
  brand_is_grayv: boolean | null;
  brand_is_tpg: boolean | null;
  cc_to_user_: User;
  cc_to_user_id: number | null;
  created_by_user: User;
  created_by_user_id: number | null;
  is_completed: boolean | null;
  is_high_priority: boolean | null;
  is_open: boolean | null;
  is_system_note: boolean | null;
  is_user_note: boolean | null;
  max_create_date: Date | null;
  max_create_date_offset: number | null;
  max_due_date: Date | null;
  max_due_date_offset: number | null;
  max_start_date: Date | null;
  max_start_date_offset: number | null;
  min_create_date: Date | null;
  min_create_date_offset: number | null;
  min_due_date: Date | null;
  min_due_date_offset: number | null;
  min_start_date: Date | null;
  min_start_date_offset: number | null;
  name: string;
  parent_types: string | null;
  subject: string | null;
  task_is_completed: boolean | null;
  task_is_open: boolean | null;
  task_to_user_: User;
  task_to_user_id: number | null;
  user: User;
  user_id: number | null;
}

export interface NoteType {
  id: number;
  created_at: Date | null;
  name: string;
  updated_at: Date;
}

export interface NoteUser {
  id: number;
  created_at: Date | null;
  has_task_assigned: boolean;
  is_watcher: boolean;
  note: Note;
  note_id: number;
  task_is_completed: boolean;
  updated_at: Date | null;
  user: User;
  user_id: number;
}

export interface NotionSlackChannel {
  id: number;
  channel_move_count: number;
  created_at: Date | null;
  exported_at: Date | null;
  last_caught_up_at: Date | null;
  notionSlackMessages: NotionSlackMessage[];
  updated_at: Date | null;
}

export interface NotionSlackMessage {
  id: number;
  channel_move_count: number;
  created_at: Date | null;
  notionSlackChannel: NotionSlackChannel;
  notion_slack_channel_id: number;
  removed_from_notion: boolean;
  updated_at: Date | null;
}

export interface NotionWebhookEvent {
  id: number;
  created_at: Date | null;
  event_timestamp: Date | null;
  processed_at: Date | null;
  received_at: Date;
  updated_at: Date | null;
  updated_property_ids: any[] | null;
}

export interface NotionWebhookVerificationToken {
  id: number;
  received_at: Date;
  verification_token: string;
}

export interface OrchardTrack {
  id: number;
  artists: string | null;
  files: string | null;
  genre: string | null;
  is_artist_match: boolean;
  is_isrc_match: boolean;
  isrc: string | null;
  remix: string | null;
  should_ingest: boolean;
  title: string | null;
}

export interface OverrideType {
  id: number;
  name: string | null;
}

export interface PageDefinition {
  id: number;
  created_at: Date | null;
  modelPermissionDefinitions: ModelPermissionDefinition;
  sort_order: number;
  updated_at: Date | null;
  user_page_grants: UserPageGrant[];
}

export interface ParentalAdvisoryType {
  id: number;
  name: string | null;
}

export interface Part {
  id: number;
  location_zone_id: number | null;
  name: string | null;
  part_entries: PartEntry[];
  position: number | null;
  template_day_id: number | null;
  template_id: number | null;
}

export interface PartEntry {
  id: number;
  bucket: Bucket;
  bucket_id: number | null;
  duration: number | null;
  part: Part;
  part_id: number | null;
}

export interface PaymentType {
  id: number;
  name: string | null;
}

export interface PerPlaySourceType {
  id: number;
  name: string;
}

export interface PhoneNumber {
  id: number;
  categories: Category;
  created_at: Date | null;
  number: string;
  phoneables: Phoneable[];
  updated_at: Date;
}

export interface Phoneable {
  id: number;
  created_at: Date | null;
  f_id: number;
  f_type: string;
  owner: Phoneable;
  phone_number: PhoneNumber;
  phone_number_id: number;
  updated_at: Date;
}

export interface PlayLogImportProgress {
  id: number;
  completed_at: Date | null;
  first_date: Date | null;
  job_id: string | null;
  last_date: Date | null;
  last_updated_at: Date | null;
  lines_processed: number | null;
  percent_complete: number | null;
  play_month: string;
  play_month_play_count: number | null;
  s3_key: string;
  started_at: Date | null;
  total_created: number | null;
  total_lines: number | null;
  total_processed: number | null;
  total_skipped: number | null;
}

export interface Player {
  id: number;
  alternate_dns_1: string | null;
  alternate_dns_2: string | null;
  auth_tok: string | null;
  check_interval: number | null;
  created_at: Date | null;
  curlcli: boolean | null;
  location_zone_players: LocationZonePlayer[];
  nrm: string | null;
  player_server: PlayerServer;
  player_server_id: number | null;
  player_type: PlayerType;
  player_type_id: number | null;
  protocol: string | null;
  stream_logging: boolean | null;
  throttle: number | null;
  time_zone: string | null;
  time_zone_id: number | null;
  timezone: TimeZone;
  updated_at: Date | null;
  use_public_dns_servers: boolean | null;
}

export interface PlayerServer {
  id: number;
  created_at: Date | null;
  name: string | null;
  players: Player[];
  short_name: string | null;
  updated_at: Date | null;
}

export interface PlayerType {
  id: number;
  name: string | null;
  players: Player[];
}

export interface PlaylistGenerationAttempt {
  id: number;
  add_command_issued: string | null;
  attempt_time_stamp: Date;
  autogen: boolean;
  autoload: number;
  cli_command: string | null;
  created_at: Date | null;
  debug_repeats: string | null;
  did_copy_to_dynamo: boolean;
  expiration: Date | null;
  is_beta_generator: boolean;
  location_zone: LocationZone;
  location_zone_id: number;
  location_zone_name: string | null;
  number_of_days: number | null;
  pg_version: string | null;
  playlist_generation_status: PlaylistGenerationStatus;
  playlist_generation_status_id: number | null;
  playlists_count: number | null;
  start_date: Date | null;
  status: number;
  success: number;
  template: Template;
  template_id: number | null;
  template_name: string | null;
  user: User;
  user_id: number | null;
  verified_by: string | null;
  verified_download_date: Date | null;
  verified_location_zone_player_id: number | null;
  zip_path: string | null;
}

export interface PlaylistGenerationFailure {
  id: number;
  attempt: PlaylistGenerationAttempt;
  attempt_id: number | null;
  deleted_at: Date | null;
  error_message: string;
  failure_type: string;
  location_zone: LocationZone;
  location_zone_id: number;
  occurred_at: Date;
}

export interface PlaylistGenerationStatus {
  id: number;
  name: string;
  playlist_generation_attempts: PlaylistGenerationAttempt[];
}

export interface PlaylistManagerGroup {
  id: number;
  accounts: Account[];
  created_at: Date;
  name: string;
  updated_at: Date;
}

export interface PlaylistTrack {
  id: number;
  bucket: Bucket;
  custom_playlist: LocationZoneCustomPlaylist;
  location_zone: LocationZone;
  location_zone_id: number | null;
  source_id: number;
  source_is_bucket: boolean;
  track_id: number;
}

export interface PlaylistTrackCount {
  source_id: number;
  source_is_bucket: boolean;
  track_count: number;
  track_count_counted_at: Date;
}

export interface PlaylistTrackRefreshChangedTrack {
  id: number;
  created_at: Date;
  track_id: number;
}

export interface RawDdexErnMessage {
  id: number;
  behalf_party_id: any[] | null;
  created_at: Date | null;
  ern_version: string;
  file_name: string | null;
  message_date: Date;
  message_id: string;
  message_thread_id: string | null;
  message_type: string;
  processed_date: Date | null;
  raw_ddex_sound_recording_releases: RawDdexSoundRecordingRelease[];
  raw_ddex_tracks: RawDdexTrack[];
  raw_ddex_xml_file: RawDdexXmlFile;
  raw_ddex_xml_file_id: number | null;
  receiver_party_id: any[] | null;
  release_count: number;
  sender_party_id: any[] | null;
  skipped_at: Date | null;
  skipped_exclusion: RawDdexPartyExclusion;
  skipped_raw_ddex_party_exclusion_id: number | null;
  skipped_reason: string | null;
  sound_recording_count: number;
  update_indicator: string | null;
  updated_at: Date | null;
}

export interface RawDdexInvalidLabelUrlCheck {
  id: number;
  content_length: number | null;
  content_type: string | null;
  created_at: Date | null;
  detail: string | null;
  http_status: number | null;
  raw_ddex_sound_recording_release: RawDdexSoundRecordingRelease;
  raw_ddex_sound_recording_release_id: number;
  source_column: string;
  updated_at: Date | null;
  url: string;
  url_hash: string;
  verdict: string;
}

export interface RawDdexMessageType {
  id: number;
}

export interface RawDdexParty {
  id: number;
  created_at: Date | null;
  name: string;
  party_id: string;
  raw_ddex_tracks_as_sender: RawDdexTrack[];
  raw_ddex_tracks_as_sent_on_behalf_of: RawDdexTrack[];
  updated_at: Date | null;
}

export interface RawDdexPartyExclusion {
  id: number;
  configuration: DdexConfiguration;
  created_at: Date | null;
  created_by_user: User;
  created_by_user_id: number | null;
  ddex_configuration_id: number;
  raw_ddex_party_sender_id: number | null;
  raw_ddex_party_sent_on_behalf_of_id: number | null;
  reason: string | null;
  sender: RawDdexParty;
  sent_on_behalf_of: RawDdexParty;
  tracks_purge_queued_at: Date | null;
  tracks_purged_at: Date | null;
  updated_at: Date | null;
}

export interface RawDdexReleaseType {
  id: number;
  created_at: Date | null;
  name: string;
  raw_ddex_sound_recording_releases: RawDdexSoundRecordingRelease[];
  updated_at: Date | null;
}

export interface RawDdexSoundRecordingRelease {
  id: number;
  album_artists: any[] | null;
  album_name: string | null;
  artists: any[] | null;
  audio_file_checksum: string | null;
  audio_file_s3_path: string | null;
  bitrate: number | null;
  catalog_number: string | null;
  commercial_model_type: any[] | null;
  copyright: number | null;
  cover_art_hash: any[] | null;
  cover_art_s3_path: any[] | null;
  cover_art_type: any[] | null;
  created_at: Date | null;
  duration: number | null;
  ean: string | null;
  excluded_territory_codes: any[] | null;
  genre_name: string | null;
  grid: string | null;
  icpn: string | null;
  isrc: string | null;
  major_record_label_name: string | null;
  message_date: Date | null;
  parental_advisory: string | null;
  processed_date: Date | null;
  publishers: any[] | null;
  raw_ddex_ern_message: RawDdexErnMessage;
  raw_ddex_ern_message_id: number;
  raw_ddex_message_type: RawDdexMessageType;
  raw_ddex_message_type_id: number;
  raw_ddex_release_type: RawDdexReleaseType;
  raw_ddex_release_type_id: number | null;
  raw_ddex_track_takedown_status: RawDdexTrackTakedownStatus;
  raw_ddex_track_takedown_status_id: number | null;
  raw_ddex_tracks: RawDdexTrack;
  record_label_name: string | null;
  release_reference: string | null;
  release_resource_reference: string | null;
  release_type: string | null;
  resource_contributors: any[] | null;
  sub_genre_name: string | null;
  sub_title: any[] | null;
  territory_codes: any[] | null;
  title: any[] | null;
  upc: string | null;
  updated_at: Date | null;
  usage: any[] | null;
  validity_period: any[] | null;
}

export interface RawDdexTrackEchoprintState {
  id: number;
  codever: string | null;
  created_at: Date | null;
  failure_count: number;
  fingerprinted_at: Date | null;
  fp_code: string | null;
  match_attempted_at: Date | null;
  raw_ddex_track: RawDdexTrack;
  raw_ddex_track_id: number;
  updated_at: Date | null;
}

export interface RawDdexTrackFingerprintMatch {
  id: number;
  confidence_score: number | null;
  created_at: Date | null;
  fingerprint_via: string;
  live_track: LiveTrack;
  live_track_code: string;
  live_track_id: number;
  raw_ddex_track: RawDdexTrack;
  raw_ddex_track_id: number;
  updated_at: Date | null;
}

export interface RawDdexTrackTakedownStatus {
  id: number;
}

export interface RawDdexXmlFile {
  id: number;
  bucket: string;
  etag: string;
  processed_date: Date | null;
  raw_ddex_ern_messages: RawDdexErnMessage;
  s3_file_path: string;
  size: number;
}

export interface RecordLayout {
  id: number;
  created_at: Date | null;
  definition: any[];
  entity: string;
  owner_key: number;
  updated_at: Date | null;
  user: User;
  user_id: number | null;
}

export interface RefreshToken {
  id: number;
  expires_at: Date;
  replacedBy: RefreshToken;
  revoked_at: Date | null;
  user: User;
}

export interface Region {
  id: number;
  deleted_at: Date | null;
}

export interface PerPlayCountryOandaExchangeRate {
  id: number;
  created_at: Date | null;
  rate: number | null;
  report_month: Date | null;
}

export interface PerPlayCountryRate {
  id: number;
  per_zone_minima: number | null;
  per_zone_minima_all_labels: number | null;
  record_label_id: number | null;
}

export interface PerPlayReportGenerationAttempt {
  id: number;
  datetime: Date | null;
  generation_number: number | null;
  report_type_id: number | null;
}

export interface RoyaltyImportProgress {
  id: number;
  batches_processed: number;
  bytes_processed: number;
  completed_at: Date | null;
  first_date: Date | null;
  job_id: string | null;
  last_date: Date | null;
  last_updated_at: Date | null;
  play_month: string;
  rows_deduplicated: number;
  rows_missing_track: number;
  rows_out_of_timeframe: number;
  rows_processed: number;
  rows_unprocessed_dropped: number;
  rows_written: number;
  s3_key: string;
  source_type: string;
  started_at: Date | null;
  total_bytes: number | null;
  total_lines: number | null;
}

export interface SavedView {
  id: number;
  color: string | null;
  created_at: Date | null;
  definition: any[];
  definition_version: number;
  entity: string;
  forkedFromSharedSavedView: SharedSavedView;
  forked_from_shared_saved_view_id: number | null;
  icon: string | null;
  name: string;
  updated_at: Date | null;
  user: User;
  user_id: number;
}

export interface ScheduleHistory {
  id: number;
  action: string;
  after: any[] | null;
  before: any[] | null;
  created_at: Date;
  locationZone: LocationZone;
  location_zone_id: number | null;
  schedule: LocationZoneCustomPlaylistSchedule;
  schedule_id: number | null;
  user: User;
  user_id: number | null;
}

export interface SchedulingMode {
  id: number;
  name: string;
}

export interface Account extends Searchable {
  id: number;
  _displayName: 'Account';
  _slug: 'account';
  account_manager_user: User;
  account_manager_user_id: number | null;
  account_status: AccountStatus;
  account_status_id: number;
  addresses: Address;
  can_skip: boolean;
  can_vote: boolean;
  categories: Category;
  client_user_ids: any[] | null;
  contacts: Contact;
  created_at: Date;
  deleted_at: Date | null;
  download_end_hour: number | null;
  download_start_hour: number | null;
  is_archived: boolean;
  is_onboarding: boolean;
  is_tpg_account: boolean | null;
  location_zones: LocationZone[];
  locations: Location[];
  name: string;
  onboarding_user: User;
  onboarding_user_id: number | null;
  phone_numbers: PhoneNumber;
  physical_address: string;
  playlist_manager_group: PlaylistManagerGroup;
  playlist_manager_group_id: number | null;
  tags: Tag;
  updated_at: Date;
  website_url: string | null;
}

export interface Album extends Searchable {
  id: number;
  _displayName: 'Album';
  _slug: 'album';
  active: boolean;
  artist: Artist;
  artist_id: number;
  code: string;
  deleted_at: Date | null;
  genre: Genre;
  genre_id: number;
  name: string;
  record_label: RecordLabel;
  record_label_id: number;
  release_date: Date | null;
  tags: Tag;
  upc: string | null;
}

export interface Artist extends Searchable {
  id: number;
  _displayName: 'Artist';
  _slug: 'artist';
  active: boolean;
  albums: Album[];
  aliases: ArtistAlias[];
  deleted_at: Date | null;
  display_string: string;
  name: string | null;
  stream_only: boolean | null;
  tags: Tag;
  tracks: LiveTrack[];
}

export interface Bucket extends Searchable {
  id: number;
  _displayName: 'Bucket';
  _slug: 'bucket';
  account: Account;
  base_bucket: Bucket;
  base_bucket_id: number | null;
  base_bucket_zt_tracks: Zt[];
  bucket_artist_excludes: Artist[];
  bucket_artist_overrides: BucketArtistOverride[];
  bucket_genres: BucketGenre[];
  bucket_tag_excludes: Tag[];
  bucket_tag_overrides: BucketTagOverride[];
  bucket_track_excludes: LiveTrack[];
  bucket_track_includes: LiveTrack[];
  bucket_track_overrides: BucketTrackOverride[];
  bucket_track_requests: LiveTrack[];
  bucket_type_id: number | null;
  created_at: Date | null;
  deleted_at: Date | null;
  ignores_base_bucket_genres: boolean;
  is_archived: boolean;
  is_base_bucket: boolean;
  location: Location;
  location_zone: LocationZone;
  location_zone_id: number | null;
  max_percentage_of_manual_tracks: number;
  min_percentage_of_preferred_tracks: number;
  name: string;
  short_description: string | null;
  sourced_custom_playlists: LocationZoneCustomPlaylist[];
  tags: Tag;
  updated_at: Date;
  zt_tracks: Zt[];
}

export interface Contact extends Searchable {
  id: number;
  _displayName: 'Contact';
  _slug: 'contact';
  brand: Brand;
  brand_id: number | null;
  categories: Category;
  client_user_ids: any[] | null;
  created_at: Date | null;
  cw_link_sent: boolean;
  cw_link_sent_date: Date | null;
  cw_link_sent_user: User;
  cw_link_sent_user_id: number | null;
  email: string;
  first_name: string | null;
  instore_location_zone: LocationZone;
  instore_location_zone_id: number | null;
  is_archived: boolean;
  is_tpg_contact: boolean | null;
  last_name: string | null;
  owners: Contactable[];
  tags: Tag;
  temporary_instore_expiration: Date | null;
  title: string | null;
  updated_at: Date;
  votes_count: number;
}

export interface ContactLoginCustomPlaylist extends Searchable {
  id: number;
  _displayName: 'Contact Custom Playlist';
  _slug: 'contact_custom_playlist';
  client_user_ids: any[] | null;
  contact_login: ContactLogin;
  contact_login_custom_playlist_tracks: ContactLoginCustomPlaylistTrack[];
  contact_login_id: number;
  created_at: Date | null;
  created_by_user: User;
  created_by_user_id: number;
  is_archived: boolean;
  name: string;
  tags: Tag;
  updated_at: Date;
}

export interface ContactLoginStation extends Searchable {
  id: number;
  _displayName: 'Station';
  _slug: 'contact_login_station';
  all_tracks_voted_off: boolean | null;
  allow_subscriber_customization: boolean;
  client_user_ids: any[] | null;
  clientweb_interactive: boolean | null;
  clientweb_published: boolean | null;
  clientweb_shuffle: boolean | null;
  clientweb_voting: boolean | null;
  code: string;
  contact: Contact;
  contact_login: ContactLogin;
  contact_login_id: number;
  contact_login_station_source: ContactLoginCustomPlaylist | LocationZone | LocationZoneCustomPlaylist;
  contact_login_station_source_id: number | null;
  contact_login_station_source_table_name: string | null;
  contact_login_station_source_type: ContactLoginStationSourceType;
  contact_login_station_source_type_id: number | null;
  created_at: Date | null;
  expiration: Date | null;
  geo_allowed_cities: string | null;
  geo_allowed_countries: string | null;
  is_broken: boolean | null;
  is_review_station: boolean | null;
  is_tpg_link: boolean | null;
  master_contact_login_station: ContactLoginStation;
  master_contact_login_station_id: number | null;
  mobile_published: boolean | null;
  mobile_sample: boolean | null;
  mobile_shuffle: boolean | null;
  name: string;
  playlist_offset: number | null;
  short_clip_playback_type: ShortClipPlaybackType;
  short_clip_playback_type_id: number | null;
  short_clips: boolean | null;
  should_expire: boolean;
  should_show_track_info: boolean;
  shuffle_seed: number | null;
  tags: Tag;
  time_zone: TimeZone;
  time_zone_id: number;
  updated_at: Date | null;
  vote_destination_location_zone: LocationZone;
  vote_destination_location_zone_id: number | null;
  web_geo_ip: boolean | null;
  web_interactive: boolean | null;
  web_logging: boolean | null;
  web_login_disabled: boolean;
  web_published: boolean | null;
  web_sample: boolean | null;
  web_should_loop: boolean;
  web_shuffle: boolean | null;
}

export interface LiveTrack extends Searchable {
  id: number;
  _displayName: 'Live Track';
  _slug: 'live_track';
  active: boolean;
  album: Album;
  album_id: number;
  artist: Artist;
  artist_id: number;
  bitrate: number | null;
  catalog_code: string | null;
  code: string | null;
  copyright: number | null;
  cover_art_s3_path: string | null;
  cover_art_signed_url: string | null;
  cover_art_updated_at: Date | null;
  created_at: Date | null;
  did_check_lyrics: boolean;
  disabled_reason: string | null;
  does_have_tasting_note: boolean | null;
  duration: number | null;
  fade_in_duration: number;
  fade_in_start: number;
  fade_out_duration: number;
  fade_out_start: number;
  file_updated_at: Date | null;
  genre: Genre;
  genre_id: number;
  is_in_use: number;
  is_sound_exchange: boolean;
  isrc: string | null;
  latest_live_track_action: LiveTrackAction;
  latest_live_track_action_id: number | null;
  live_track_deals: LiveTrackDeal[];
  live_track_echoprint_state: LiveTrackEchoprintState;
  live_track_matches: LiveTrackMatch[];
  lyrics: TrackLyrics;
  lyrics_check_status: LyricsCheckStatus;
  lyrics_check_status_id: number | null;
  lyrics_check_status_updated_at: Date | null;
  lyrics_check_status_updated_by_user: User;
  lyrics_check_status_updated_by_user_id: number | null;
  match_sender_party_ids: any[] | null;
  match_sent_on_behalf_of_party_ids: any[] | null;
  name: string | null;
  normalized_level: number;
  original_duration: number | null;
  parental_advisory_type: ParentalAdvisoryType;
  parental_advisory_type_id: number | null;
  playlist_count: number;
  playlist_usages: PlaylistTrack[];
  rating: string | null;
  raw_ddex_record_label_name: string;
  raw_ddex_root_record_label_name: string;
  raw_ddex_root_record_label_party: RawDdexParty;
  raw_ddex_root_record_label_party_id: number;
  raw_ddex_track: RawDdexTrack;
  raw_ddex_track_id: number | null;
  record_label: RecordLabel;
  record_label_id: number;
  remix_name: string | null;
  remix_source_track: LiveTrack;
  remix_source_track_id: number | null;
  requested_for_user: User;
  requested_for_user_id: number | null;
  staged_track_source: StagedTrackSource;
  staged_track_source_id: number | null;
  tags: Tag;
  track_match_status: TrackMatchStatus;
  track_match_status_id: number;
  track_match_types: any[] | null;
  updated_at: Date;
  uploaded_date: Date | null;
}

export interface LiveTrackAction extends Searchable {
  id: number;
  _displayName: 'Live Track Action';
  _slug: 'live_track_action';
  audio_file_completed_at: Date | null;
  can_retry: boolean;
  cover_art_completed_at: Date | null;
  created_at: Date | null;
  deleted_at: Date | null;
  encoded_audio_fields: any[] | null;
  error_messages: string | null;
  live_track: LiveTrack;
  live_track_action_status: LiveTrackActionStatus;
  live_track_action_status_id: number | null;
  live_track_backup: any[] | null;
  live_track_code: string | null;
  live_track_id: number | null;
  metadata_completed_at: Date | null;
  performed_by_user: User;
  performed_by_user_id: number | null;
  raw_ddex_track: RawDdexTrack;
  raw_ddex_track_id: number | null;
  rollback_to_action: LiveTrackAction;
  rollback_to_action_id: number | null;
  source: string | null;
  tags: Tag;
  update_audio_file: string | null;
  update_cover_art: string | null;
  update_fields: any[] | null;
  updated_at: Date | null;
  verify_files_before_update: boolean;
}

export interface Location extends Searchable {
  id: number;
  _displayName: 'Location';
  _slug: 'location';
  account: Account;
  account_id: number;
  addresses: Address;
  already_open: boolean;
  alt_store_number: string | null;
  categories: Category;
  category: Category;
  category_id: number;
  client_user_ids: any[] | null;
  contacts: Contact;
  deleted_at: Date | null;
  franchisee: Location;
  franchisee_id: number | null;
  is_archived: boolean;
  is_music_zone_holder: boolean;
  is_onboarding: boolean;
  location_status: LocationStatus;
  location_status_id: number;
  location_zones: LocationZone[];
  name: string;
  onboarding_user: User;
  onboarding_user_id: number | null;
  phone_numbers: PhoneNumber;
  physical_address: string;
  region: Region;
  region_id: number;
  startup_date: Date | null;
  store_number: string | null;
  tags: Tag;
  website_url: string | null;
}

export interface LocationZone extends Searchable {
  id: number;
  _displayName: 'Location Zone';
  _slug: 'location_zone';
  account: Account;
  addresses: Address;
  autogen_attempts: PlaylistGenerationAttempt[];
  banned_artists: BannedArtist[];
  banned_tracks: BannedTrack[];
  beta_pg: boolean | null;
  buckets: Bucket[];
  categories: Category;
  contacts: Contact;
  content_cycle: number | null;
  content_style: ContentStyle;
  content_style_id: number | null;
  content_styling_frequency: number | null;
  cost_level: number | null;
  create_notification_sent: boolean | null;
  created_at: Date | null;
  created_by_user: User;
  created_by_user_id: number | null;
  custom_publishes: LocationZoneContentPublish[];
  default_template: Template;
  default_template_id: number | null;
  deleted_at: Date | null;
  description: string | null;
  does_use_ach_push: boolean;
  does_use_ach_recurring: boolean;
  does_use_check: boolean;
  does_use_credit_card: boolean;
  final_onboarding_email_sent: boolean;
  five_day_followup: boolean | null;
  followup_frequency_days: number | null;
  has_master_service_agreement: boolean | null;
  hide_internal_votes: boolean;
  holiday_default_template: Template;
  holiday_default_template_id: number | null;
  ignore_master_location_zone_votes: boolean;
  initial_onboarding_email_user: User;
  initial_onboarding_email_user_id: number | null;
  instore_player_contacts: Contact[];
  invoiced: boolean;
  is_archived: boolean;
  is_internal: boolean;
  is_music_zone: boolean;
  is_onboarding: boolean;
  is_past_due: boolean;
  is_past_due_date: Date | null;
  is_past_due_user: User;
  is_past_due_user_id: number | null;
  is_tpg_location_zone: boolean;
  last_content_checkup_reminder_date: Date | null;
  last_followup_date: Date | null;
  last_followup_user: User;
  last_followup_user_id: number | null;
  last_onboarding_email_date: Date | null;
  latest_autogen_attempt: PlaylistGenerationAttempt;
  location: Location;
  location_id: number;
  location_zone_custom_playlist_sources: string | null;
  location_zone_custom_playlists: LocationZoneCustomPlaylist[];
  location_zone_fee: LocationZoneFee;
  location_zone_playback_timeframes: LocationZonePlaybackTimeframe[];
  location_zone_players: LocationZonePlayer[];
  location_zone_status: LocationZoneStatus;
  location_zone_status_id: number | null;
  location_zone_tier: LocationZoneTier;
  location_zone_tier_id: number;
  loop_lists: boolean;
  master_location_zone: LocationZone;
  master_location_zone_id: number | null;
  monthly_payment_type: PaymentType;
  monthly_payment_type_id: number | null;
  music_zone_folders: MusicZoneFolder;
  name: string;
  onboarding_manager_user: User;
  onboarding_manager_user_id: number | null;
  onboarding_user: User;
  onboarding_user_id: number | null;
  payments_tally: number;
  phone_numbers: PhoneNumber;
  physical_address: string;
  playlist_cycle: number;
  playlist_generation_attempts: PlaylistGenerationAttempt[];
  playlist_manager_group: PlaylistManagerGroup;
  playlist_manager_group_id: number | null;
  recurring_followup_user: User;
  recurring_followup_user_id: number | null;
  rotate_requirement: number;
  scheduling_mode: SchedulingMode;
  scheduling_mode_id: number | null;
  should_include_master_location_zone_votes: boolean;
  startup_date: Date | null;
  startup_payment_type: PaymentType;
  startup_payment_type_id: number | null;
  subscribers: LocationZone[];
  subscribers_count: number;
  tags: Tag;
  time_zone: TimeZone;
  time_zone_id: number;
  updated_at: Date;
  user: User;
  user_id: number | null;
  website_url: string | null;
}

export interface LocationZoneCustomPlaylist extends Searchable {
  id: number;
  OLD_use_daily_playlists: boolean | null;
  _displayName: 'Custom Playlist';
  _slug: 'location_zone_custom_playlist';
  account: Account;
  artist_repeat_limit_hours: number | null;
  code: string | null;
  cover_track: LiveTrack;
  cover_track_id: number | null;
  created_at: Date | null;
  created_from_script: boolean;
  deleted_at: Date | null;
  details: string | null;
  download_priority: number | null;
  effective_location_zone: LocationZone;
  effective_location_zone_custom_playlist_schedules: LocationZoneCustomPlaylistSchedule[];
  expiration_date: Date | null;
  expiration_time_zone: TimeZone;
  expiration_time_zone_id: number | null;
  is_interactive: boolean;
  is_published: boolean;
  is_sample_list: boolean | null;
  is_visible_to_client: boolean;
  location: Location;
  location_zone: LocationZone;
  location_zone_custom_playlist_schedules: LocationZoneCustomPlaylistSchedule[];
  location_zone_custom_playlist_status: LocationZoneCustomPlaylistStatus;
  location_zone_custom_playlist_status_id: number;
  location_zone_custom_playlist_tracks: LocationZoneCustomPlaylistTrack[];
  location_zone_id: number | null;
  location_zone_is_archived: boolean;
  name: string;
  should_download_to_players: boolean | null;
  show_track_info: boolean;
  shuffle: boolean | null;
  source_bucket: Bucket;
  source_bucket_id: number | null;
  source_bucket_is_vault: boolean;
  special_event: boolean;
  status_expiration: Date | null;
  status_expiration_timezone: TimeZone;
  status_expiration_timezone_id: number | null;
  tags: Tag;
  tracks: LiveTrack;
  updated_at: Date | null;
  user: User;
  user_can_shuffle: boolean;
  user_id: number | null;
  z_delimited_track_ids: string | null;
}

export interface LocationZoneCustomPlaylistSchedule extends Searchable {
  id: number;
  _displayName: 'Custom Playlist Schedule';
  _slug: 'custom_playlist_schedule';
  complete_track: boolean | null;
  created_at: Date | null;
  custom_playlist_insert_type: CustomPlaylistInsertType;
  custom_playlist_insert_type_id: number | null;
  custom_playlist_schedule_type: CustomPlaylistScheduleType;
  custom_playlist_schedule_type_id: number | null;
  date: string | null;
  deleted_at: Date | null;
  delimited_day_ids: string | null;
  effective_end_datetime: Date | null;
  effective_start_datetime: Date | null;
  end_date: string | null;
  end_time: string | null;
  ignore_dl_window: boolean | null;
  insert_frequency_ramp_days: number;
  insert_frequency_tracks_start: number;
  insert_frequency_tracks_target: number;
  is_recurring: boolean;
  location_zone: LocationZone;
  location_zone_custom_playlist: LocationZoneCustomPlaylist;
  location_zone_custom_playlist_id: number | null;
  location_zone_id: number | null;
  loop: boolean | null;
  messaging_end_time: string | null;
  messaging_frequency_minutes: number | null;
  messaging_start_time: string | null;
  natural_language_date_expression: string | null;
  natural_language_end_date_expression: string | null;
  priority: number | null;
  recurring_end_date: string | null;
  recurring_start_date: string | null;
  recurring_weekly_interval: number;
  resume_from_file_offset: boolean | null;
  revert_to_daily: boolean | null;
  should_shuffle: boolean;
  silence: boolean | null;
  station_change_location_zone_player: LocationZonePlayer;
  station_change_location_zone_player_id: number | null;
  time: string | null;
  updated_at: Date | null;
}

export interface LocationZonePlayer extends Searchable {
  id: number;
  _displayName: 'Location Zone Player';
  _slug: 'location_zone_player';
  account: Account;
  audio_device: string;
  brand_id: number | null;
  can_set_volume: boolean | null;
  can_skip: boolean;
  can_vote: boolean;
  client_did_set_muted: boolean | null;
  client_did_set_volume: boolean;
  complete_track: boolean | null;
  created_at: Date | null;
  crossfade_duration: number | null;
  crossfade_type: CrossfadeType;
  crossfade_type_id: number | null;
  deleted_at: Date | null;
  download_end_hour: number | null;
  download_start_hour: number | null;
  last_loaded_archive: string | null;
  last_loaded_date: Date | null;
  location: Location;
  location_zone: LocationZone;
  location_zone_id: number | null;
  location_zone_player_data: LocationZonePlayerData[];
  location_zone_player_stream_mode: LocationZonePlayerStreamMode;
  location_zone_player_stream_mode_id: number | null;
  mono: boolean | null;
  player: Player;
  player_alternate_dns_1: string;
  player_alternate_dns_2: string;
  player_check_interval: number;
  player_curlcli: boolean;
  player_data_channels: string;
  player_data_checkin_marker: Date;
  player_data_current_playlist_name: string;
  player_data_current_track_code: string;
  player_data_date: Date;
  player_data_disk_size_gb: number;
  player_data_disk_usage: string;
  player_data_disk_usage_percentage: number;
  player_data_dns_1: string;
  player_data_dns_2: string;
  player_data_drive: string;
  player_data_gateway: string;
  player_data_internal_ip: string;
  player_data_ip_mode: string;
  player_data_is_internal: boolean;
  player_data_is_online: boolean;
  player_data_kernel: string;
  player_data_lan: string;
  player_data_last_loaded_archive: string;
  player_data_last_loaded_date: Date;
  player_data_mac_address: string;
  player_data_model_type: string;
  player_data_playing: number;
  player_data_playlist_track_number: number;
  player_data_playlist_track_total: number;
  player_data_proxy: string;
  player_data_referenced_content_missing: number;
  player_data_referenced_content_total: number;
  player_data_remote_ip: string;
  player_data_subnet: string;
  player_data_time_zone: string;
  player_data_updated_at: Date;
  player_data_version: string;
  player_data_volume: number;
  player_id: number | null;
  player_nrm: string;
  player_protocol: string;
  player_server: PlayerServer;
  player_stream_logging: boolean;
  player_throttle: number;
  player_time_zone: string;
  player_type: PlayerType;
  player_use_public_dns_servers: boolean;
  set_volume_contact: Contact;
  set_volume_contact_id: number;
  tags: Tag;
  updated_at: Date | null;
  volume: number;
}

export interface LocationZonePlayerParsedPlaylistTrack extends Searchable {
  id: number;
  _displayName: 'Location Zone Player Parsed Playlist Track';
  _slug: 'location_zone_player_parsed_playlist_track';
  created_at: Date | null;
  location_zone_player_id: number;
  location_zone_player_parsed_playlist_id: number;
  position: number;
  track_id: number;
  updated_at: Date | null;
}

export interface MusicZoneFolder extends Searchable {
  id: number;
  _displayName: 'Music Zone Folder';
  _slug: 'music_zone_folder';
  created_at: Date | null;
  description: string | null;
  location_zones: LocationZone;
  name: string;
  owner: User;
  owner_user_id: number;
  updated_at: Date | null;
}

export interface RawDdexTrack extends Searchable {
  id: number;
  _displayName: 'Ddex Track';
  _slug: 'raw_ddex_track';
  album_artists: any[] | null;
  album_name: string | null;
  artists: any[] | null;
  audio_file_checksum: string | null;
  audio_file_s3_path: string | null;
  bitrate: number | null;
  catalog_number: string | null;
  commercial_model_type: any[] | null;
  copyright: number | null;
  cover_art_hash: string | null;
  cover_art_s3_path: string | null;
  cover_art_signed_url: string | null;
  cover_art_type: string | null;
  created_at: Date | null;
  duration: number | null;
  ean: string | null;
  excluded_territory_codes: any[] | null;
  genre_name: string | null;
  grid: string | null;
  icpn: string;
  isrc: string | null;
  major_record_label_name: string | null;
  message_date: Date;
  parental_advisory: string | null;
  publishers: any[] | null;
  raw_ddex_ern_message: RawDdexErnMessage;
  raw_ddex_ern_message_id: number;
  raw_ddex_party_sender: RawDdexParty;
  raw_ddex_party_sender_id: number | null;
  raw_ddex_party_sent_on_behalf_of: RawDdexParty;
  raw_ddex_party_sent_on_behalf_of_id: number | null;
  raw_ddex_release_type: RawDdexReleaseType;
  raw_ddex_release_type_id: number | null;
  raw_ddex_sound_recording_releases: RawDdexSoundRecordingRelease;
  raw_ddex_track_echoprint_state: RawDdexTrackEchoprintState;
  raw_ddex_track_fingerprint_matches: RawDdexTrackFingerprintMatch[];
  raw_ddex_track_takedown_status: RawDdexTrackTakedownStatus;
  raw_ddex_track_takedown_status_id: number | null;
  record_label_name: string | null;
  release_reference: string | null;
  release_resource_reference: string | null;
  release_type: string | null;
  sub_genre_name: string | null;
  sub_title: string | null;
  territory_codes: any[] | null;
  title: string | null;
  upc: string | null;
  updated_at: Date | null;
  usage: any[] | null;
  validity_period: any[] | null;
}

export interface RecordLabel extends Searchable {
  id: number;
  _displayName: 'Record Label';
  _slug: 'record_label';
  albums: Album[];
  categories: Category;
  deleted_at: Date | null;
  dpid: string | null;
  is_active: boolean;
  isrc_is_required: boolean;
  name: string;
  parent_record_label: RecordLabel;
  parent_record_label_id: number | null;
  sub_record_labels: RecordLabel[];
  tags: Tag;
  tracks: LiveTrack[];
}

export interface Template extends Searchable {
  id: number;
  _displayName: 'Template';
  _slug: 'template';
  account: Account;
  created_at: Date | null;
  is_archived: boolean;
  location: Location;
  location_zone: LocationZone;
  location_zone_id: number | null;
  location_zones: LocationZone[];
  name: string | null;
  parts: Part[];
  skip_unique_artists: boolean;
  skip_unique_genres: boolean;
  tags: Tag;
  template_days: TemplateDay[];
  updated_at: Date;
}

export interface SharedSavedView {
  id: number;
  color: string | null;
  created_at: Date | null;
  definition: any[];
  definition_version: number;
  entity: string;
  icon: string | null;
  name: string;
  share_key: string;
  sharedByUser: User;
  shared_by_user_id: number | null;
  sourceSavedView: SavedView;
  source_saved_view_id: number | null;
  updated_at: Date | null;
}

export interface ShortClipPlaybackType {
  id: number;
  name: string | null;
}

export interface StagedTrack {
  id: number;
  album_artist_id: number | null;
  album_artist_name: string | null;
  album_id: number | null;
  album_name: string | null;
  album_upc: string | null;
  artist_id: number | null;
  artist_name: string | null;
  bitrate: number | null;
  catalog_code: string | null;
  checksum: string | null;
  checksum_hash_function: string | null;
  code: string | null;
  copyright: number | null;
  created_at: Date | null;
  did_check_lyrics: boolean | null;
  downloaded_as_file_name: string | null;
  duplicate_track_ids: string | null;
  duration: number | null;
  error_text: string | null;
  fade_in_duration: number;
  fade_in_start: number;
  fade_out_duration: number;
  fade_out_start: number;
  file_location: string | null;
  fingerprint: string | null;
  fingerprint_code_version: string | null;
  fingerprint_duration: number | null;
  fingerprint_offset: number | null;
  genre_id: number | null;
  genre_name: string | null;
  is_archived: boolean;
  is_conflicted: boolean | null;
  is_error: boolean;
  is_in_use: number;
  is_ready_for_processing: boolean | null;
  is_sound_exchange: boolean | null;
  isrc: string | null;
  lyrics: TrackLyrics;
  lyrics_check_status_id: number;
  lyrics_check_status_updated_at: Date | null;
  lyrics_check_status_updated_by_user_id: number | null;
  name: string | null;
  normalized_level: number;
  original_duration: number | null;
  parental_advisory_type_id: number | null;
  performance_rights_organizations_raw: string | null;
  process_user_id: number | null;
  publishers_raw: string | null;
  record_label_id: number | null;
  record_label_name: string | null;
  region: string | null;
  remix_name: string | null;
  replace_track_id: number | null;
  requested_for_location_zone_id: number | null;
  requested_for_user_id: number | null;
  review_1_done: boolean | null;
  review_2_done: boolean | null;
  review_3_done: boolean | null;
  staged_track_parental_advisory_type_id: number;
  staged_track_process_type_id: number;
  staged_track_processing_state_id: number;
  staged_track_source_id: number;
  tags: Tag;
  updated_at: Date | null;
  upload_monitor_job_id: number | null;
  upload_user_id: number | null;
  uploaded_date: Date | null;
}

export interface StagedTrackProcessType {
  id: number;
  created_at: Date | null;
  name: string | null;
  updated_at: Date;
}

export interface StagedTrackSource {
  id: number;
}

export interface State {
  id: number;
  abbreviation: string;
  name: string;
}

export interface StreamMode {
  id: number;
  name: string | null;
  players: Player[];
}

export interface Tag {
  id: number;
  child_tags: Tag[];
  created_at: Date | null;
  default_exclude: boolean;
  is_artist_tag: boolean;
  is_creative: boolean;
  is_header_tag: boolean;
  is_track_user_tag: boolean;
  name: string;
  parent_tag: Tag;
  parent_tag_id: number | null;
  position: number;
  track_tag: boolean;
  updated_at: Date;
  vault_tag: boolean;
}

export interface Taggable {
  id: number;
  created_at: Date | null;
  f_id: number;
  f_type: string;
  tag: Tag;
  tag_id: number;
  taggable: Taggable;
  updated_at: Date;
  user: User;
  user_id: number | null;
}

export interface TemplateDay {
  id: number;
  created_at: Date | null;
  day: Day;
  day_id: number;
  parts: Part[];
  start_time: string | null;
  template: Template;
  template_id: number;
  updated_at: Date;
}

export interface TemplateDayInsert {
  id: number;
  created_at: Date | null;
  end_time: string | null;
  insert: Insert;
  insert_id: number;
  priority: number;
  start_time: string | null;
  template_day: TemplateDay;
  template_day_id: number;
  updated_at: Date;
}

export interface TimeZone {
  id: number;
  abbreviation: string | null;
  dst_abbreviation: string | null;
  iana_name: string | null;
  is_dst_aware: boolean;
  name: string | null;
  notes: string | null;
  offset: number | null;
}

export interface TrackLyrics {
  id: number;
  created_at: Date | null;
  f_id: number;
  f_type: string;
  fetched_artist: string | null;
  fetched_title: string | null;
  language: string | null;
  lyrics_body: string | null;
  lyrics_fetch_completed_generation: number;
  lyrics_fetch_generation: number;
  lyrics_fetch_job_log_partition_key: string | null;
  lyrics_fetch_last_job_log: string | null;
  source_name: string | null;
  source_reference: string | null;
  translation_links: any[] | null;
  updated_at: Date | null;
}

export interface TrackMatchStatus {
  id: number;
  name: string;
}

export interface TrackStreamType {
  id: number;
  live_tracks: LiveTrack[];
  name: string | null;
}

export interface User {
  id: number;
  api_endpoint_id: number;
  app_version: string | null;
  clients_only: boolean;
  created_at: Date | null;
  crypted_password: string | null;
  deleted_at: Date | null;
  email: string;
  email_verified_at: Date | null;
  first_name: string;
  group_id: number;
  gvdev_slack_code: string | null;
  gvdev_slack_id: string | null;
  is_accountant: boolean;
  is_developer: boolean;
  is_human: boolean;
  is_onboarder: boolean;
  is_stylist: boolean;
  is_tester: boolean;
  is_tpg_user: boolean;
  last_crud_message_id: number | null;
  last_poll: number | null;
  logged_in_mac: string | null;
  login: string;
  modelPermissions: UserModelPermission[];
  name: string;
  os_version: string | null;
  password: string;
  remember_token: string | null;
  remember_token_expires_at: Date | null;
  reset_storage_file: boolean;
  should_send_debug_email: boolean;
  show_in_access_view: boolean;
  sillc_slack_code: string | null;
  sillc_slack_id: string | null;
  time_zone_id: number | null;
  time_zone_name: string | null;
  updated_at: Date;
  zdesktop_mac: string | null;
  zlaptop_mac: string | null;
  zother_mac: string | null;
}

export interface UserModelPermission {
  id: number;
  can_create: boolean;
  can_delete: boolean;
  can_update: boolean;
  can_view: boolean;
  user: User;
  user_id: number;
}

export interface UserPageGrant {
  id: number;
  page_definition: PageDefinition;
  user: User;
}

export interface VoteReason {
  id: number;
  name: string;
  overrideType: OverrideType;
  override_type_id: number;
  position: number | null;
  voteType: VoteType;
  vote_type_id: number | null;
}

export interface VoteType {
  id: number;
  name: string | null;
  voteReasons: VoteReason[];
}

export interface Worklist {
  id: number;
  created_at: Date | null;
  location_zone_custom_playlists: LocationZoneCustomPlaylist;
  location_zones: LocationZone;
  music_zone_folders: MusicZoneFolder;
  name: string | null;
  updated_at: Date | null;
  user: User;
  user_id: number;
}

export interface Zp {
  id: number;
  created_at: Date;
  delimited_bucket_ids: string;
  delimited_track_codes: string;
  delimited_track_details: string;
  delimited_track_ids: string;
  location_zone_id: number;
  play_date_time: Date;
  playlist_generation_attempt_id: number;
  success: boolean;
  updated_at: Date;
}

export interface ZpgaLog {
  id: number;
  created_at: Date;
  message: string;
  playlist_generation_attempt_id: number;
}

export interface Zt {
  id: number;
  bucket: Bucket;
  bucket_id: number;
  created_at: Date | null;
  duration: number | null;
  location_zone: LocationZone;
  location_zone_id: number | null;
  track: LiveTrack;
  track_id: number;
  updated_at: Date;
  user: User;
  user_id: number | null;
}

export const ONLINE_WITHIN_MINUTES = 5;
export const QUICK_SEARCH_ACCENT_VARIANTS = {"a":"a\u00e0\u00e1\u00e2\u00e3\u00e4\u00e5\u0101\u0103\u0105","e":"e\u00e8\u00e9\u00ea\u00eb\u0113\u0117\u0119","i":"i\u00ec\u00ed\u00ee\u00ef\u012b\u012f","o":"o\u00f2\u00f3\u00f4\u00f5\u00f6\u014d\u0151","u":"u\u00f9\u00fa\u00fb\u00fc\u016b\u016f","c":"c\u00e7\u0107\u010d","n":"n\u00f1\u0144","s":"s\u015b\u0161","y":"y\u00fd\u00ff"};

